import { useCallback } from "react";
import PropTypes from "prop-types";

import { t } from "../../../services";

import { Paragraph2 } from "../../../components";
import { ColorIndicator, LegendItemsList } from "../styled";

const ChartLegend = ({ metricsConfig, labelValuesConfig = {}, opacity, setOpacity }) => {
  const handleMouseEnter = useCallback(
    (entry) => {
      const { id } = entry;

      const temp = Object.assign({}, opacity);
      Object.keys(temp).forEach((v) => (temp[v] = 0.3));

      temp[id] = 1;

      setOpacity(temp);
    },
    [opacity, setOpacity]
  );

  const handleMouseLeave = useCallback(() => {
    const temp = Object.assign({}, opacity);
    Object.keys(temp).forEach((v) => (temp[v] = 1));
    setOpacity(temp);
  }, [opacity, setOpacity]);

  return (
    <LegendItemsList>
      {metricsConfig &&
        Object.keys(metricsConfig)?.map((metric, index) => {
          const entry = metricsConfig[metric];
          let labelValue = null;

          if (labelValuesConfig && labelValuesConfig?.length) {
            labelValue =
              labelValuesConfig?.find((config) => config.id === entry.id)?.labelValue ?? null;
          }

          return labelValue ? (
            <li
              key={index}
              onMouseEnter={() => handleMouseEnter(entry)}
              onMouseLeave={() => handleMouseLeave()}>
              <ColorIndicator color={entry?.color} />

              <Paragraph2>{t(entry.name)}</Paragraph2>

              <span>{labelValue}</span>
            </li>
          ) : null;
        })}
    </LegendItemsList>
  );
};

ChartLegend.propTypes = {
  metricsConfig: PropTypes.shape(PropTypes.object).isRequired,
  labelValuesConfig: PropTypes.arrayOf(PropTypes.object).isRequired,
  opacity: PropTypes.objectOf(PropTypes.number),
  setOpacity: PropTypes.func.isRequired
};

export default ChartLegend;
